import { ActionContext, ActionTree } from 'vuex';

import { TimeSample, TimeSyncState } from './types';

import loggerService from '@/services/logger.service';
import { getTimekeeperTime } from '@/services/session.service';

export const actions: ActionTree<TimeSyncState, any> = {
  async calculateOffset(context: ActionContext<TimeSyncState, any>, attempts = 6) {
    const results: TimeSample[] = [];

    for (let i = 0; i < attempts; i++) {
      const t0 = performance.now();
      const clientSend = Date.now();

      const data = await getServerTime();

      if (!data) {
        continue;
      }
      const clientReceive = Date.now();
      const t1 = performance.now();

      const serverTimestamp = data.unix_timestamp;

      const clientMidpoint = (clientSend + clientReceive) / 2;
      const offset = serverTimestamp - clientMidpoint;
      const roundTripTime = t1 - t0;

      results.push({ offset, roundTripTime });

      // add delay between samples to spread them out, giving independent, more realistic measurements and avoid server load spikes
      await new Promise(r => setTimeout(r, 100));
    }

    // Pick the sample with the lowest RoundTripTime - lowers delay between client and server
    const bestSample = results.reduce((best, current) => (current.roundTripTime < best.roundTripTime ? current : best));

    context.commit('setOffset', Math.round(bestSample.offset));
  }
};

async function getServerTime(): Promise<{ unix_timestamp: number }> {
  try {
    const res = await getTimekeeperTime();
    if (!res?.body) {
      return { unix_timestamp: 0 };
    }
    const reader = res?.body?.getReader();
    const readResult = await reader?.read();
    const text = new TextDecoder().decode(readResult?.value);
    return JSON.parse(text);
  } catch (e) {
    loggerService.warn('Error getting server time', e);
    return { unix_timestamp: 0 };
  }
}
